import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { APP_NAME } from '@/components/layout/brand'
import { BrandMark } from '@/components/layout/BrandMark'
import { cn } from '@/lib/utils'

/**
 * The shell for every screen reached without a session: sign-in, the password reset, and the two
 * dead ends. Centred, branded, and narrow — there is no navigation to offer at this point.
 */
export function AuthShell({ children, className }: { children: ReactNode; className?: string }) {
  const { t } = useTranslation()

  return (
    <div className="bg-muted/40 flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className={cn('flex w-full max-w-sm flex-col gap-6', className)}>
        <Link
          to="/"
          className="hover:text-foreground/80 flex items-center gap-2 self-center font-medium transition-colors"
        >
          <BrandMark className="size-6" />
          <span>{APP_NAME}</span>
          <span className="sr-only">— {t('app.tagline')}</span>
        </Link>
        {children}
      </div>
    </div>
  )
}
